import React from 'react';
import toast from 'react-hot-toast';
import { DEFAULT_PATH_BEFORE_SIGN_IN } from '@apps/config';
import { DialogContentText } from '@mui/material';
import { Dialog } from '@stack/components';
import { useLogoutMutation } from '@stack/data-access';
import { redirect, useAuthIdentity } from '@webbyx/next-js';
import { clearAuthToken } from '@webbyx/next-js/dist/helpers/token';

import { Props } from './props';

const LogoutDialogContainer: React.FC<Props> = (props) => {
  const { open, onClose } = props;
  const { signOut } = useAuthIdentity();
  // ======================= API
  const [logoutMutation] = useLogoutMutation({
    onCompleted: (data) => {
      if (data?.Logout?.status) {
        redirect({}, DEFAULT_PATH_BEFORE_SIGN_IN, 'replace');
        clearAuthToken();
        signOut();
      }
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  const handleLogout = () => {
    logoutMutation();
  };

  return (
    <Dialog
      title={'Log Out'}
      open={open}
      onClose={onClose}
      MainActionButtonProps={{
        label: 'Logout',
        color: 'primary',
        onClick: handleLogout,
      }}
    >
      <DialogContentText>
        Are you sure you want to log out? You will return to the login screen.
      </DialogContentText>
    </Dialog>
  );
};

export default LogoutDialogContainer;
